import { Injectable } from '@angular/core';
import { TrackingItem } from '@stylehaven/components';

@Injectable()
export abstract class TrackingProviderService {
    abstract init(trackingItems: TrackingItem[]): void;
    abstract registerPageView(currentUrl: string): void;
}
